module.exports = __webpack_public_path__ + "resources/img/img-deep-security-01-3.f8517063c39d3628d363eb9bc4c2ae51.png";